import {Grid, Row, Col, Button, Image, Glyphicon} from 'react-bootstrap';
import {connect} from 'react-redux';

import React, {Component} from 'react';
import './preview.css';
import CameraButton from '../../components/buttons/camera_button/CameraButton';
import imageProcess from '../../library/ImageProcess';
import {setImage, setLoader, setShowError, setErrorType} from '../../redux/actionCreators';
import MainButton from '../../components/buttons/main_button/MainButton';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';

class Preview extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            acceptButtonState: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.image && this.acceptButton) {
            this.setState({acceptButtonState: true});
        }
    }

    getImage = async (event, fileInput) => {
        try {
            const image = await imageProcess.getImageFromFileInput(event, fileInput);
            this.props.setImage(image);
        } catch (error) {
            this.props.setErrorType('defaultImage');
        }
    };

    rotateImage = async () => {
        const image = await imageProcess.rotateImage(this.props.image);
        this.props.setImage(image);
    };

    launchCamera = (inputFile) => {
        inputFile.click();
    };

    isNextButtonDisabled = () => {
        return !this.state.acceptButtonState && !(this.props.image && this.props.image.length > 10);
    }

    render() {
        let suggestionIcon, suggestionMessage;
        if (this.props.stepInfo.suggestion !== undefined) {
            suggestionIcon = require(`../../resources/images/${this.props.stepInfo.suggestion.icon}`).default;
            suggestionMessage = this.props.stepInfo.suggestion.message;
        }
        return (
            <div className={'preview page-layout'}>
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <Col xs={6}>
                                <CameraButton
                                    text={'Repetir'}
                                    getImage={this.getImage}
                                    isRepeat={true}
                                    launchCamera={this.launchCamera}
                                    ref={cameraButton => this.cameraButton = cameraButton}
                                    outline
                                />
                            </Col>
                            <Col xs={6}>
                                <MainButton
                                    ref={acceptButton => this.acceptButton = acceptButton}
                                    disabled={this.isNextButtonDisabled()}
                                    onClick={this.props.nextStep}
                                    className={'next-button'}
                                >
                                    Continuar
                                </MainButton>
                            </Col>
                        </FooterContainer>
                    )}
                >
                    <Grid>
                        <div className="content">
                        <Row>
                            {!this.props.isStepPreviewCirculationPermission ?
                                <div className={'rotate-button'}>
                                    <Button onClick={this.rotateImage}>
                                        <Glyphicon glyph="repeat"/>
                                    </Button>
                                </div> :
                                <div className='content-indication'>
                                    <p>
                                        Revisa que la imagen sea legible; si no lo es, inténtalo de nuevo.
                                    </p>
                                </div>
                            }
                        </Row>
                        <Row>
                            <Col xs={12} className={'content-image'}>
                                {this.props.image !== undefined ? 
                                <><p className={'content-description'}>Revisa que la imagen sea legible; si no lo es, inténtalo de nuevo.</p></>
                                :
                                <div className={'content-suggestion'}>
                                    <p>{suggestionMessage}</p>
                                    <Image src={suggestionIcon}/>
                                </div>
                                }
                                
                                <Image src={this.props.image}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {this.props.message}
                            </Col>
                        </Row>
                        </div>
                    </Grid>
                </PageWithFooter>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        image: state.image,
        showError: state.showError,
        loader: state.loader,
        setErrorType: state.setErrorType,
        stepInfo: state.stepInfo
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Preview);